var BaseView = require('../components/accordion-list/categories-director');
var SearchView = require('../search/search');

module.exports = BaseView.extend({
  templates: {
    'mls': require('./search-results/mls.hbs')
  },

  events: _.extend({
    'click .search-close': 'closeSearchEvent'
  }, BaseView.prototype.events),

  initialize: function () {
    _.bindAll(this, 'refreshAntiscroll', 'searchCallback', 'addThumbnail', 'mapResult');
    BaseView.prototype.initialize.call(this);
  },

  search: function ($searchInput) {
    var $imageList = this.$el.find('.image-list');
    var $tabContent = $imageList.find('.tab-content');
    this.tool = INKIVE.Tool.getInstance();

    this.$el.find('.search-title').removeClass('hidden');
    $imageList.find('.antiscroll-scrollbar').remove();
    $tabContent.css('height', '').empty().removeData();
    this.$el.siblings('.search-container').addClass('disabled');
    this.$searchOptions.toggle(false);

    this.searchView = this.searchView || new SearchView();
    this.searchView.initSearch($imageList, {
      query: $searchInput.val(),
      type: this.type,
      callback: this.refreshAntiscroll,
      url: this.getSearchUrl($searchInput.val()),
      authErrorCallback: this.authErrorCallback,
      skipScrollDetect: this.searchType === 'postal_code'
    }, this.searchCallback);
  },

  searchCallback: function (elems) {
    return _.chain(elems)
      .map(this.mapResult)
      .each(this.addThumbnail);
  },

  closeSearchEvent: function (event) {
    var $searchTitle = $(event.currentTarget).parents('.search-title');
    var searchInput = this.$el.closest('.tab-content').find('.search-container input');

    $searchTitle.addClass('hidden');
    this.$el.find('.tab-content').empty();
    searchInput.val('');
    searchInput.toggleClass('searching');
  },

  refreshAntiscroll: function () {
    this.$el.siblings('.search-container').removeClass('disabled');
    if (this.searchType === 'postal_code') {
      return;
    }

    this.$el.find('.antiscroll-wrap').antiscroll({horizontal: false});
    this.$el.find('.antiscroll-scrollbar').css('left', 304);
  },

  refresh: _.noop,

  addThumbnail: function (item) {
    var template = this.templates[this.type]({
      item: item,
      longId: item.id && item.id.length > 10
    });

    this.$el.find('.tab-content').append(template);
  }
});
